export default __webpack_public_path__ + "static/media/Group 19.77ae268d.png";